export enum Status {
    Invalid = "Invalid",
    Valid = "Valid",
    Unchecked = "Unchecked",
    Verified = "Verified",
    NONE = ""
}
export enum Task {
    RichiediBC = "RichiediBC",
    Registration = "Registration",
    RegistratiConBC = "RegistratiConBC",
    RegistratiSenzaBC = "RegistratiSenzaBC",
    NONE = ""
}
export interface IKeyboard {
    options?: any,
    target?: string,
    container?: string
}
export interface PuntoDiVendita {
    "codePdv": string,
    "descriptionPdv": string,
    "codPdvDrive"?: string,
    "descriptionPdvDrive"?: string
}

export interface MFA {
    "code": string,
    "description": string
}



export class Info {
    codTessera: string = '';
    canale: string = '';
    nome: string = '';
    cognome: string = '';
    dataDiNascita: string = '';
    cf?: string = '';
    sesso: string = null;
    nazionalita: string = '';
    anonimo: string = '';
    luogoDiNascita: string = '';
    mustResetPwd: string = '';
    cod2FAuth: string = '';
}

export class Account {
    email: string = '';
    emailStatus?: Status;
    password: string = '';
    registrato: boolean = false;
}

export class Contacts {
    email?: string = '';
    emailStatus?: Status;
    cellulare: string = '';
    cellulareStatus?: Status;
}
export class Address {
    stato: string = '';
    provincia: string = '';
    localita: string = '';
    via: string = '';
    cap: string = '';
    civico: string = '';
    longitudine: string = '';
    latitudine: string = '';
    istatRegionale: string = '';
    istatComunale: string = '';
    sezioneCensimento: string = '';
    resultCode: string= '';
}
export class PDV {

    "preferenze" = {
        "ritiroPremi": "",
        "preferito": "",
        "drive": ""
    }
    "interessi": Array<any> = [
        {
            "code": "A",
            "description": "Auto",
            "value": 'N'
        },
        {
            "code": "B",
            "description": "Bambini",
            "value": 'N'
        },
        {
            "code": "F",
            "description": "Fai da te",
            "value": 'N'
        },
        {
            "code": "G",
            "description": "Gardinaggio",
            "value": 'N'
        },
        {
            "code": "P",
            "description": "Animali",
            "value": 'N'
        },
        {
            "code": "S",
            "description": "Bio e Salutistica",
            "value": 'N'
        },
        {
            "code": "T",
            "description": "Tecnologia",
            "value": 'N'
        },
        {
            "code": "V",
            "description": "Gourmet e Vini",
            "value": 'N'
        },
        {
            "code": "W",
            "description": "Sport e Tempo libero",
            "value": 'N'
        }
    ]
    "privacy": Array<any> = [
        { "code": "GDPR", "desc": "GDPR", "value": null, "favoriteMethod": null },
        { "code": "MARKETING", "desc": "MARKETING", "value": null, "favoriteMethod": null },
        { "code": "PROFILAZIONE", "desc": "PROFILAZIONE", "value": null, "favoriteMethod": null },
        { "code": "E", "desc": "Consenso Invio Mail", "value": 'N', "favoriteMethod": null },
        { "code": "S", "desc": "Consenso Invio SMS/MMS", "value": 'N', "favoriteMethod": null },
        { "code": "T", "desc": "Consenso Telefono", "value": 'N', "favoriteMethod": null },
        { "code": "P", "desc": "Consenso Postalizzazione", "value": 'N', "favoriteMethod": null },
        { "code": "I", "desc": "Consenso Invio Instant Message", "value": 'N', "favoriteMethod": null }
    ]
}

export class User {

    info = new Info()
    account = new Account()
    contacts = new Contacts()
    address = new Address()
    pdv = new PDV()

    constructor() {

    }
}
export function Copy(object) {
    if (typeof object == 'object') {
        object = object || {};
        return JSON.parse(JSON.stringify(object))
    }
    else
        return {}
}


// WEBPACK FOOTER //
// ./src/app/theme/models/user.model.ts